import React, { useEffect, useState } from "react";
import {
  OptionContainer,
  OptionContent,
  OptionLabel,
  SettingsOptionContainer,
} from "../../../styles";
import { CreatableSelect, Select } from "@caelor/ui";
import { useTranslation } from "react-i18next";
import { useNewsStore } from "../../../../../../../stores/use-news-store";
import SpacePicker from "../../../../../../../components/ui/space-picker/SpacePicker";
import ContributorsPicker from "../../../../../../../components/ui/people-picker/ContributorsPicker";

const createOption = (label) => ({
  label,
  value: label,
});

const Sorting = {
  CREATED: "created",
  MODIFIED: "modified",
  TITLE: "title",
};

function Dynamic() {
  const { t } = useTranslation();

  const { data, selectedTab, updateConfigTab } = useNewsStore((state) => ({
    data: state.data,
    selectedTab: state.getSelectedTab(),
    updateConfigTab: state.updateConfigTab,
  }));

  const [labels, setLabels] = useState([]);
  const [inputValue, setInputValue] = useState(undefined);

  useEffect(() => {
    if (data.config.tabs[selectedTab].labels) {
      setLabels(
        data.config.tabs[selectedTab].labels.map((l) => createOption(l))
      );
    }
  }, [data.config.tabs[selectedTab].labels]);

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        setInputValue("");
        setLabels([...labels, createOption(inputValue)]);
        updateConfigTab({
          value: {
            labels: [
              ...data.config.tabs[selectedTab].labels,
              createOption(inputValue),
            ].map((l) => l.label),
          },
        });
        event.preventDefault();
        break;
      default:
        return;
    }
  };

  const sortingOptions = [
    { label: t("title"), value: Sorting.TITLE },
    { label: t("create-date"), value: Sorting.CREATED },
  ];

  return (
    <>
      <SettingsOptionContainer>
        <OptionContainer direction="column">
          <OptionLabel>{t("spaces")}</OptionLabel>
          <OptionContent full>
            <SpacePicker
              initialSpaces={data.config.tabs[selectedTab].spaces}
              placeholder={t("select-spaces")}
              isMulti
              onUpdate={(value) => {
                updateConfigTab({ value: { spaces: value } });
              }}
            />
          </OptionContent>
        </OptionContainer>
        <OptionContainer direction="column">
          <OptionLabel>{t("contributors")}</OptionLabel>
          <OptionContent full>
            <ContributorsPicker
              placeholder={t("select-contributors")}
              initialAccountIDs={data.config.tabs[selectedTab].contributors}
              isMulti
              onUpdate={(value) => {
                updateConfigTab({ value: { contributors: value } });
              }}
            />
          </OptionContent>
        </OptionContainer>
        <OptionContainer direction="column">
          <OptionLabel>{t("labels")}</OptionLabel>
          <OptionContent full>
            <CreatableSelect
              inputValue={inputValue}
              isClearable
              isMulti
              onChange={(newLabels) => {
                setLabels(newLabels);
                updateConfigTab({
                  value: {
                    labels: newLabels.map((l) => l.label),
                  },
                });
              }}
              placeholder={t("select-labels")}
              menuIsOpen={false}
              onInputChange={(newValue) => setInputValue(newValue)}
              onKeyDown={handleKeyDown}
              hideDropdownIcon
              value={labels}
            />
          </OptionContent>
        </OptionContainer>
        <OptionContainer direction="column">
          <OptionLabel>{t("sort-by")}</OptionLabel>
          <OptionContent full>
            <Select
              options={sortingOptions}
              value={sortingOptions.find(
                ({ value }) => value === data.config.tabs[selectedTab].sorting
              )}
              onChange={(value) => {
                updateConfigTab({ value: { sorting: value.value } });
              }}
            />
          </OptionContent>
        </OptionContainer>
      </SettingsOptionContainer>
    </>
  );
}

export default Dynamic;
